
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.453 15.037l-3.193-.798-.272-1.087a5.745 5.745 0 001.613-3.199c.473-.133.84-.539.903-1.048l.209-1.667a1.246 1.246 0 00-.798-1.321l.077-1.57.311-.312c.47-.5.859-1.355.045-2.597C14.723.484 13.662 0 12.192 0c-.58 0-1.915 0-3.159.835C5.483.909 5 2.558 5 4.167c0 .374.09 1.216.15 1.725a1.251 1.251 0 00-.863 1.348l.209 1.666c.068.543.48.97 1.002 1.072a5.781 5.781 0 001.533 3.102l-.29 1.16-3.193.8A4.674 4.674 0 000 19.582c0 .23.187.417.417.417h19.166c.23 0 .417-.188.417-.418a4.677 4.677 0 00-3.547-4.545z","fill":"#E2E8F0"}})])
          )
        }
      }
    